import React, { useEffect } from "react";
import UrlTag from "../components/UrlTag";
import Carousel from "../components/Carousel";
import studio1 from '../Images/heroSection1.jpg';
import main1 from '../Images/main1.jpg';

const images = [
    studio1,
    main1,
    studio1,
    main1,
];

const Project1 = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    return (
        <div className="z-20">
            <UrlTag />
            <div className="relative">
                <img src={studio1} alt="Project 1" className="w-full h-[300px] md:h-[500px] object-cover" />
                <div className="absolute inset-0 bg-black opacity-40"></div>
                <div className="absolute bottom-0 left-0 py-4 sm:py-6 md:py-8 px-4 sm:px-6 md:px-8 lg:px-14">
                    <h1 className="text-white text-3xl sm:text-4xl font-bold">Project 1</h1>
                </div>
            </div>
            <div className="max-w-[900px] mx-auto p-4 sm:p-8 md:p-16">
                <div>
                    <div className="py-10 flex justify-center">
                        <button onClick={() => scrollToSection('carousel')} className="text-gray-500 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-2">Image Gallery</button>
                    </div>
                    <div className="border border-gray-200 mb-4" />
                    <p className="text-lg mb-8 tracking-wider text-gray-700 font-light">
                        Located 80 kilometres south of Kuwait City, South Sabah Al-Ahmad City is set to be the urban core for the country’s southern sub-region. The city will be home to an estimated 280,000 people, while creating another 145,000 jobs in a diverse range of industries including construction, medicine, manufacturing and culture, along with extensive green open spaces and multi-layered public transport systems that promote wellbeing and sustainability.
                    </p>
                </div>
                <div id='carousel' className="mb-10">
                    <Carousel images={images} />
                </div>
            </div>
        </div>
    );
};

export default Project1;